import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { TicketExtraView, TicketExtraViewProxy } from '../views/ticketextra';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { TicketType } from '../types';
import { ExtraType } from '../types';

import { Ticket } from './ticket';

const _schema = {
    "name": "TICKETEXTRA",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "ticket", type: "objid" },
        { name: "extra", type: "objid" },
        { name: "taxrate", type: "number" },
        { name: "charge", type: "number" },
        { name: "refund", type: "number" }
    ],
    relate: [
        { direction: ">", target: "TICKET", by: "ticket", name: "ticket", reason: "ticket", child: false, class: TicketType },
        { direction: ">", target: "EXTRA", by: "extra", name: "extra", reason: "extra", child: false, class: ExtraType }
    ]
} as const;

const _TicketExtraClass = CreateObject(_schema);
if (!_TicketExtraClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class TicketExtra extends _TicketExtraClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): TicketExtra {
        return this._Copy(store) as TicketExtra;
    }

    override get viewProxy(): TicketExtraView {
        return TicketExtraViewProxy(this, this.data);
    }

    /** Changelog rows lack `TICKET.extras`; register on link (see TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || relation !== 'ticket' || !(related instanceof Ticket)){
            return;
        }

        if (related === this.ticket){
            related.AddExtra(this);
        }
        else {
            related.DelExtra(this);
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/
    
    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.ticket){
            if ((this.status == 'DE') && !this.Commited){
                this.ticket.DelExtra(this);
            }
            else {
                this.ticket.DoRefresh(this.table);
            }    
        }
    }  
    
    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }   
}    
